import classNames from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';

import { useBoolean } from '@sravni/react-utils';

import styles from './wysiwyg.module.scss';

const ReactQuill = dynamic(() => import('react-quill'), { ssr: false });

interface IProps {
  textValue: string;
  placeholder: string;
  handleTextChange: (value: string) => void;
  invalid: boolean;
}

export const Wysiwyg: React.FC<IProps> = ({ textValue, placeholder, handleTextChange, invalid }) => {
  const [focused, setFocused] = useBoolean(false);

  const modules = {
    toolbar: [['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
  };

  const _classNames = classNames(styles.wrapper, {
    [styles['wrapper--invalid']]: invalid,
    [styles['wrapper--focused']]: focused,
  });

  return (
    <div className={_classNames}>
      <ReactQuill
        value={textValue}
        onChange={handleTextChange}
        placeholder={placeholder}
        modules={modules}
        formats={['bold', 'italic', 'list', 'bullet', 'link']}
        onFocus={() => setFocused.on()}
        onBlur={() => setFocused.off()}
      />
    </div>
  );
};
